import { memo, useCallback } from 'react';
import { Link } from 'react-scroll';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import { articleScrollConfig } from 'screens/editorial/asset/utility/reactScrollProps';
import { useAssetViewContext } from 'screens/editorial/asset/context/AssetViewContextProvider';
import { InsertItemLayout } from '../InsertItemLayout/InsertItemLayout';
import { useTranslation } from 'react-i18next';

type CoverArtOptionProps = {
  onSelect?: () => void;
};

export const CoverArtOption = memo(({ onSelect }: CoverArtOptionProps) => {
  const { setEditCoverArtMode } = useAssetViewContext();
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    setEditCoverArtMode('upload');
    onSelect?.(); // Close the menu
  }, [onSelect, setEditCoverArtMode]);

  return (
    <Link
      to="content-cover"
      {...articleScrollConfig}
      onClick={handleClick}
      data-testid="cover-art-option-test-id"
    >
      <InsertItemLayout
        id="widget-select-cover"
        key="widget-select-cover"
        title={t('blox.editorial.asset.cover.label')}
        icon={<WallpaperIcon sx={(theme) => ({ color: theme.blox.iconColors.cover })} />}
        description={t('blox.editorial.asset.cover.description')}
      />
    </Link>
  );
});
CoverArtOption.displayName = 'CoverArtOption';
